import React, { useEffect, useState } from 'react';
import styles from './DateNumberBody.module.scss';
import { Form } from 'antd';
import DispexInput from '../../../../components/DispexInput';
import { docTypes } from '../../constants/documents.constants';
import DatePickerCustom from '../DatePickerCustom/DatePickerCustom';
import { enumTypePicker } from '../DatePickerCustom/constants';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { useSelector } from 'react-redux';
import useDeadlineDateQuery from '../../queries/useDeadlineDateQuery';
import moment from 'moment';

const DateNumberBody = ({ form }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const { formValues, mode, savedDraft } = useSelector(documentDrawerSelector);

  const docType = getFieldValue('typeId');

  const showTypesDoc = [docTypes.incoming, docTypes.citizenAppeal];

  const showDoc = docType !== docTypes.organizational;
  const showResponseTimeDoc = showTypesDoc.includes(docType);
  const showRowAdditionally =
    docType === docTypes.outgoing || docType === docTypes.incoming;

  const [docMoment, setDocMoment] = useState(null);

  const { data } = useDeadlineDateQuery(
    {
      documentTypeId: docType,
      inputDate: docMoment?.toISOString(),
      showResponseTimeDoc,
    },
    {
      enabled: Boolean(docMoment && docType && mode === 'create'),
    }
  );

  useEffect(() => {
    if (data && showResponseTimeDoc) {
      const parsed = moment(data);
      setFieldsValue({ DeadlineDate: parsed.isValid() ? parsed : null });
    }
  }, [data, setFieldsValue, showResponseTimeDoc]);

  useEffect(() => {
    const initialDocDate = getFieldValue('docDate');

    if (initialDocDate && showResponseTimeDoc && !docMoment) {
      setDocMoment(initialDocDate);
    }
  }, [getFieldValue, showResponseTimeDoc, docMoment]);

  useEffect(() => {
    if (
      (docType === docTypes.outgoing || docType === docTypes.incoming) &&
      !!savedDraft?.values &&
      (savedDraft?.values?.type?.id === docTypes.outgoing ||
        savedDraft?.values?.type?.id === docTypes.incoming)
    ) {
      setFieldsValue({
        sourceNumber: savedDraft?.values?.docNumber || null,
        sourceDate: moment(savedDraft?.values?.createDate) || null,
      });
    }
  }, [docType]);

  return (
    <div className={styles.root}>
      {showDoc && (
        <div className={styles.row}>
          <Form.Item
            label="Номер документа"
            className={styles.item}
          >
            {getFieldDecorator('DocNumber', {
              rules: [
                {
                  required: true,
                  message: 'Пожалуйста, укажите номер документа',
                },
              ],
            })(
              <DispexInput
                className={styles.inputCustom}
                placeholder="Номер"
              />
            )}
          </Form.Item>

          <Form.Item
            label="Дата регистрации"
            className={styles.item}
          >
            {getFieldDecorator('docDate', {
              initialValue: formValues?.docDate
                ? moment(formValues.docDate)
                : moment(),
              rules: [
                {
                  required: true,
                  message: 'Пожалуйста, укажите дату регистрации',
                },
              ],
            })(
              <DatePickerCustom
                typePicker={enumTypePicker.DATE}
                size="large"
                placeholder="ДД.ММ.ГГГГ"
                style={{ width: '100%' }}
                allowClear={false}
                onChange={(value) => {
                  if (!value) {
                    setFieldsValue({ DeadlineDate: null });
                    setDocMoment(null);
                    return;
                  }
                  setDocMoment(value);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}

      <div className={styles.row}>
        {showResponseTimeDoc && (
          <Form.Item
            label="Срок ответа"
            className={styles.item}
          >
            {getFieldDecorator('DeadlineDate', {
              rules: [
                { required: true, message: 'Пожалуйста, укажите срок ответа' },
              ],
            })(
              <DatePickerCustom
                typePicker={enumTypePicker.DATE}
                size="large"
                placeholder="ДД.ММ.ГГГГ"
                style={{ width: '100%' }}
                allowClear={false}
              />
            )}
          </Form.Item>
        )}

        <Form.Item
          label={
            docType === docTypes.outgoing ? 'Дата отправки' : 'Дата ответа'
          }
          className={styles.item}
        >
          {getFieldDecorator('doneDate')(
            <DatePickerCustom
              typePicker={enumTypePicker.DATE}
              size="large"
              placeholder="ДД.ММ.ГГГГ"
              style={{ width: '100%' }}
              allowClear={false}
            />
          )}
        </Form.Item>
      </div>

      {showRowAdditionally && (
        <div className={styles.row}>
          <Form.Item
            label={
              docType === docTypes.outgoing
                ? 'Номер входящего документа'
                : 'Номер исходящего документа'
            }
            className={styles.item}
          >
            {getFieldDecorator('sourceNumber')(
              <DispexInput
                className={styles.inputCustom}
                placeholder="Номер"
                title={
                  docType === docTypes.outgoing
                    ? 'Номер входящего документа, ответом на который является текущий документ'
                    : 'Номер исходящего внешнего документа'
                }
              />
            )}
          </Form.Item>
          <Form.Item
            label={
              docType === docTypes.outgoing
                ? 'Дата входящего документа'
                : 'Дата исходящего документа'
            }
            className={styles.item}
          >
            {getFieldDecorator('sourceDate')(
              <DatePickerCustom
                typePicker={enumTypePicker.DATE}
                size="large"
                placeholder="ДД.ММ.ГГГГ"
                style={{ width: '100%' }}
                format="DD.MM.YYYY"
                title={
                  docType === docTypes.outgoing
                    ? 'Дата входящего документа, ответом на который является текущий документ'
                    : 'Дата исходящего внешнего документа'
                }
              />
            )}
          </Form.Item>
        </div>
      )}
    </div>
  );
};

export default DateNumberBody;
